var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-card',{staticClass:"mt-base mb-5",attrs:{"title":"Projects"}},[_c('p',{staticClass:"mb-5"},[_vm._v("Coming Soon!")])])}
var staticRenderFns = []

export { render, staticRenderFns }